var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "createcategory"
  }, [_vm.showCreateCategoryModal ? _c('r-modal', {
    attrs: {
      "title": _vm.$t('createCategory.label'),
      "close-action-label": "Cancel",
      "action-label": _vm.$t('createCategory.label'),
      "fetching": _vm.fetchingCreateCategory,
      "action-disabled": !(_vm.name && _vm.color)
    },
    on: {
      "close": _vm.onClickCancel,
      "submit": _vm.onClickSave
    },
    scopedSlots: _vm._u([{
      key: "content",
      fn: function fn() {
        return [_c('v-form', {
          ref: "form",
          staticClass: "createcategoryform mt-5",
          model: {
            value: _vm.valid,
            callback: function callback($$v) {
              _vm.valid = $$v;
            },
            expression: "valid"
          }
        }, [_c('v-row', {
          staticClass: "mt-5",
          attrs: {
            "no-gutters": ""
          }
        }, [_c('v-col', {
          attrs: {
            "cols": "12",
            "sm": "12",
            "md": "12",
            "lg": "12"
          }
        }, [_c('r-text-field', {
          staticClass: "input-text createcategoryform--name",
          attrs: {
            "value": _vm.name,
            "label": _vm.$t('createCategory.fields.name'),
            "placeholder": "Lorem ipsum",
            "rules": [_vm.rules.required]
          },
          on: {
            "change": _vm.onNameInputChange
          }
        })], 1)], 1), _c('span', [_vm._v(" " + _vm._s(_vm.$t('createCategory.fields.color')) + " ")]), _c('color-picker', {
          attrs: {
            "show-color-picker": _vm.showColorPicker
          },
          on: {
            "select:custom-color": _vm.onSelectCustomColor
          }
        }), _c('v-row', {
          attrs: {
            "no-gutters": ""
          }
        }, [_c('v-col', {
          staticClass: "createcategoryform--colors"
        }, [_vm._l(_vm.colors, function (color, i) {
          return _c('div', {
            key: i,
            staticClass: "createcategoryform--color",
            class: {
              'selected': _vm.$data.color === color && !_vm.showColorPicker
            },
            style: 'background:' + color,
            attrs: {
              "colors": _vm.colors,
              "color": color
            },
            on: {
              "click": function click($event) {
                return _vm.onSelectColor(color);
              }
            }
          });
        }), _c('div', {
          staticClass: "createcategoryform--color-picker",
          class: {
            'selected': _vm.showColorPicker
          },
          attrs: {
            "color": _vm.color
          },
          on: {
            "click": _vm.onSelectColorPicker
          }
        })], 2)], 1)], 1), _c('r-error-message', {
          attrs: {
            "errors": [_vm.fetchCreateCategoryError]
          }
        })];
      },
      proxy: true
    }], null, false, 2792432556)
  }) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }